import React, { useEffect, useState } from 'react';
import { Globe, X } from 'lucide-react';
import { i18n, LANGS, suggestedLang, dismissSuggestion } from '../services/i18n';
import { authAPI } from '../services/api';

const TEXT = {
  en: { msg: 'This site is also available in English.', yes: 'Switch to English', no: 'Continuer en français' },
  de: { msg: 'Diese Website ist auch auf Deutsch verfügbar.', yes: 'Auf Deutsch wechseln', no: 'Continuer en français' },
  es: { msg: 'Este sitio también está disponible en español.', yes: 'Cambiar a español', no: 'Continuer en français' },
  it: { msg: 'Questo sito è disponibile anche in italiano.', yes: 'Passa all\'italiano', no: 'Continuer en français' },
};

// Shared state for the desktop banner and the compact mobile strip
export const useLangSuggest = () => {
  const [lang, setLang] = useState(suggestedLang);
  useEffect(() => i18n.subscribe(() => setLang(suggestedLang())), []);
  const close = () => { dismissSuggestion(); setLang(null); };
  const accept = () => { i18n.set(lang); if (authAPI.isAuthenticated()) authAPI.setDocLang(lang).catch(() => {}); close(); };
  return lang ? { lang, txt: TEXT[lang], flag: LANGS.find((l) => l.code === lang)?.flag, close, accept } : null;
};

// Discreet bar offered once to first-time visitors whose browser language is not French
const LanguageSuggestBanner = ({ className = '' }) => {
  const s = useLangSuggest();
  if (!s) return null;
  return (
    <div className={`bg-slate-900 text-white text-sm ${className}`} data-testid="lang-suggest-banner" role="region" aria-label="Language suggestion">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center gap-x-4 gap-y-2">
        <span className="inline-flex items-center gap-2"><Globe size={16} className="text-orange-400" />{s.flag && <img src={`https://flagcdn.com/w40/${s.flag}.png`} alt="" width={18} height={13} className="rounded-[2px]" />} {s.txt.msg}</span>
        <button type="button" onClick={s.accept} data-testid="lang-suggest-accept" className="font-semibold text-orange-400 hover:text-orange-300 underline-offset-2 hover:underline min-h-[32px] px-1">{s.txt.yes}</button>
        <button type="button" onClick={s.close} data-testid="lang-suggest-dismiss" className="text-slate-300 hover:text-white min-h-[32px] px-1">{s.txt.no}</button>
        <button type="button" onClick={s.close} aria-label="Fermer" data-testid="lang-suggest-close" className="ml-auto text-slate-400 hover:text-white inline-flex items-center justify-center w-8 h-8 -mr-2 rounded-full hover:bg-white/10"><X size={16} /></button>
      </div>
    </div>
  );
};

export default LanguageSuggestBanner;
